// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { AuthMeResponse, ListUsersResponse, UserPreferencesResponse, UserResponse } from "../user/dto.generated";
export const addTagTypes = ["auth", "users"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiAuthMe: build.query<GetApiAuthMeApiResponse, GetApiAuthMeApiArg>({
        query: () => ({ url: `/api/auth/me` }),
        providesTags: ["auth"],
      }),
      getApiUsers: build.query<GetApiUsersApiResponse, GetApiUsersApiArg>({
        query: (queryArg) => ({
          url: `/api/users`,
          params: {
            email: queryArg.email,
            username: queryArg.username,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["users"],
      }),
      postApiUsers: build.mutation<PostApiUsersApiResponse, PostApiUsersApiArg>(
        {
          query: (queryArg) => ({
            url: `/api/users`,
            method: "POST",
            body: queryArg.userCreateUserRequest,
          }),
          invalidatesTags: ["users"],
        },
      ),
      getApiUsersOauthBySubId: build.query<
        GetApiUsersOauthBySubIdApiResponse,
        GetApiUsersOauthBySubIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/oauth/${encodeURIComponent(String(queryArg.subId))}`,
        }),
        providesTags: ["users"],
      }),
      getApiUsersById: build.query<
        GetApiUsersByIdApiResponse,
        GetApiUsersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/${encodeURIComponent(String(queryArg.id))}`,
        }),
        providesTags: ["users"],
      }),
      putApiUsersById: build.mutation<
        PutApiUsersByIdApiResponse,
        PutApiUsersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/${encodeURIComponent(String(queryArg.id))}`,
          method: "PUT",
          body: queryArg.userUpdateUserRequest,
        }),
        invalidatesTags: ["users"],
      }),
      deleteApiUsersById: build.mutation<
        DeleteApiUsersByIdApiResponse,
        DeleteApiUsersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/api/users/${encodeURIComponent(String(queryArg.id))}`,
          method: "DELETE",
        }),
        invalidatesTags: ["users"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as userApi };
export type GetApiAuthMeApiResponse = /** status 200 OK */ {
  [key: string]: UserAuthMeResponse;
};
export type GetApiAuthMeApiArg = void;
export type GetApiUsersApiResponse = /** status 200 OK */ { data: UserListUsersResponse };
export type GetApiUsersApiArg = {
  /** Filter by email (partial match) */
  email?: string;
  /** Filter by username/name (partial match) */
  username?: string;
  /** Number of items to return (max 100, default 20) */
  limit?: number;
  /** Pagination cursor */
  cursor?: string;
};
export type PostApiUsersApiResponse =
  /** status 201 Created */ { data: UserUserResponse };
export type PostApiUsersApiArg = {
  /** User creation request */
  userCreateUserRequest: UserCreateUserRequest;
};
export type GetApiUsersOauthBySubIdApiResponse =
  /** status 200 OK */ { data: UserUserResponse };
export type GetApiUsersOauthBySubIdApiArg = {
  /** User IDPSub */
  subId: string;
};
export type GetApiUsersByIdApiResponse = /** status 200 OK */ { data: UserUserResponse };
export type GetApiUsersByIdApiArg = {
  /** User ID */
  id: string;
};
export type PutApiUsersByIdApiResponse = /** status 200 OK */ { data: UserUserResponse };
export type PutApiUsersByIdApiArg = {
  /** User ID */
  id: string;
  /** User update request (name and is_active are optional) */
  userUpdateUserRequest: UserUpdateUserRequest;
};
export type DeleteApiUsersByIdApiResponse = unknown;
export type DeleteApiUsersByIdApiArg = {
  /** User ID */
  id: string;
};
export type UserAuthMeResponse = AuthMeResponse;
export type UserUserPreferencesResponse = UserPreferencesResponse;
export type UserUserResponse = UserResponse;
export type UserListUsersResponse = ListUsersResponse;
export type UserCreateUserRequest = {
  email: string;
  idp_sub?: string;
  name: string;
};
export type UserAgentScopePayload = {
  project_id?: string;
  workspace_id: string;
};
export type UserUserPreferencesPayload = {
  /** Replaces where Teramot Agent starts new conversations: a workspace, and a project in it
    or none. */
  agent_scope?: UserAgentScopePayload;
  /** Personal opt-in to the monthly BI digest; without it a listed address is not mailed. */
  bi_digest_consent?: boolean;
  /** The web app's language, for what Teramot Agent's LLM proxy says on its own. */
  language?: "en" | "es";
  /** Personal opt-out from the monthly report email; wins over any workspace recipient list. */
  report_unsubscribed?: boolean;
};
export type UserUpdateUserRequest = {
  is_active?: boolean;
  name?: string;
  preferences?: UserUserPreferencesPayload;
  skip_onboarding?: boolean;
};
export const {
  useGetApiAuthMeQuery,
  useLazyGetApiAuthMeQuery,
  useGetApiUsersQuery,
  useLazyGetApiUsersQuery,
  usePostApiUsersMutation,
  useGetApiUsersOauthBySubIdQuery,
  useLazyGetApiUsersOauthBySubIdQuery,
  useGetApiUsersByIdQuery,
  useLazyGetApiUsersByIdQuery,
  usePutApiUsersByIdMutation,
  useDeleteApiUsersByIdMutation,
} = injectedRtkApi;
